export const MIN_ACCEPTABLE_ZOOM = 10;

export const CARD_HEIGHT = 325;
export const CARD_OFFSET_Y = 60;
export const CARD_WIDTH = 325;
export const CARD_OFFSET_X = 144;

export const MAP_CHANGE_DEBOUNCE_MS = 800;
export const SKELETON_COUNT = 30;
export const PRIORITY_IMAGE_THRESHOLD = 9;

export const OVERLAY_X_OFFSET = 144;
export const OVERLAY_Y_OFFSET = 50;

/**
 * Padding (in pixels) applied to `map.fitBounds()` during initial map
 * positioning. This ensures price-pill markers near the geometry edges
 * are not clipped by the viewport boundary.
 *
 * 60px accounts for the largest price-pill marker (~28px tall, up to ~70px
 * wide) plus breathing room.
 */
export const FITBOUNDS_PADDING = { top: 60, right: 60, bottom: 60, left: 60 };

/**
 * Result count below which we surface "low inventory" traveler messaging
 * (Savvy is new, adding properties fast, etc.) above the results grid.
 *
 * Triggers when `0 < totalCount < LOW_INVENTORY_THRESHOLD`. Tunable in one
 * place so product can A/B without touching the component.
 */
export const LOW_INVENTORY_THRESHOLD = 10;
